import { render, staticRenderFns } from "./layout-create.vue?vue&type=template&id=303dabb4&scoped=true"
import script from "./layout-create.vue?vue&type=script&lang=js"
export * from "./layout-create.vue?vue&type=script&lang=js"
import style0 from "./layout-create.vue?vue&type=style&index=0&id=303dabb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303dabb4",
  null
  
)

export default component.exports